// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subscriptions tr td[data-v-2fe8f898]{border-bottom:5px solid #fff!important}.subscriptions tr:last-child td[data-v-2fe8f898]{border-bottom:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
